import * as React from 'react';
import PreLaunchNav from './components/PreLaunchNav';
import PreLaunchFooter from './components/PreLaunchFooter';
import { addElementToClassName } from './AddToClass';
import * as ReactDOM from 'react-dom';
import ContactUsForm from './components/ContactUsForm';
import { PanelCollapse, Button, BUTTON_TYPE, SignUpModal, Cart } from '@bepure/tarkin';
import { default as legal } from './Legal/Legal';
import getCarouselComponent from './CarouselElement';
import { showCategoryPanel } from './PanelCollapse';
import ShippingModal from './components/ShippingModal';
import ReturnsModal from './components/ReturnsModal';
import renderOpenAddToCardModal from './Render/renderOpenAddToCardModal';
import renderPanel from './Render/renderPanel';
import attachShoppingCart from './ShoppingCart/ShoppingCart';
import CartDiv from './ShoppingCart/CardDiv';
import { NotifyMe } from './components/NotifyMe';
import { renderPrePurchaseButton, renderPrePurchaseButtonToHtml } from './PreSaleHomePage/PrePurchaseButton';
import ProgrammePitchAction from './PreSaleHomePage/ProgrammePitchAction';
import { renderEve } from './PreSaleHomePage/InstagramFeed';
import StepSection from './PreSaleHomePage/StepSection';
import CallToAction from './PreSaleHomePage/CallToAction';
import StepCarousel from './PreSaleHomePage/StepCarousel/StepCarousel';
import { PartpayBanner } from './components/PartpayBanner';
import TestimonialCarouselSection from './PreSaleHomePage/TestimonialCarousel/TestimonialCarousel';
import ProductCarouselSection from './PreSaleHomePage/ProductCarousel/ProductCarousel';
import ProfileCarouselSection from './components/ProfileCarousel';
import ProfileSection from './components/ProfileSection';
import renderFAQSection from './components/FAQSection';
import renderProductReviews from './components/ProductReviews';
import renderMiniProductReviews from './components/MiniProductReviews';
import ProductsSection from './components/ProductsSection';
import SearchBox from './components/SearchBox';
import MentionedBy from './PreSaleHomePage/MentionedBy';
import ValueBar from './PreSaleHomePage/ValueBar';
import FiveStarReviews from './components/FiveStarReviews';
import PageFeed from './components/PageFeed';
import BlogTagPanel from './components/BlogTagPanel';
import { v4 as uuidv4 } from 'uuid';
import ProductSlideShow from 'components/ProductSlideShow';
import ProductInformationWrapper from 'components/ProductInformationWrapper';
import { RegularProduct } from '@bepure/tarkin/dist/utils/cart';
import { fetchBigCommerceApi, HTTP_METHOD } from 'utils/bigCommerceAuth';
import CTATileGrid from 'components/CTATileGrid';
import ProductReviewCarousel from 'components/ProductReviewCarousel';
import ProductSeller from 'components/ProductSeller';
import './index.css';
import BenefitsCallToAction from 'components/BenefitsCallToAction';
import PromoCarousel from 'components/PromoCarousel';
import ShippingReturns from 'ShippingReturns';
declare global {
  interface Window { Obiwan: any; hbspt: any; }
}

window.Obiwan = window.Obiwan || {};
window.Obiwan.SHOPPING_CART_URL = '/cart';
declare const BASE_API_URL: string;


if (typeof BASE_API_URL !== 'undefined') {
  Cart.init({ baseApiUrl: BASE_API_URL });
  Cart.loadCart();
}

const main = () => {
  const contactUsElements = Array.from(document.getElementsByClassName('react-contact-us'));
  contactUsElements.forEach(contactUsElement => {
    const contactUs = (<ContactUsForm />);
    ReactDOM.render(contactUs, contactUsElement);
  });
};

interface PanelCollapseInputs {
  title?: string;
  content?: string;
}

const panelCollapseElements = document.getElementsByClassName('react-panel-collapse');
Array.from(panelCollapseElements).forEach(element => {
  const temp: PanelCollapseInputs = {};
  Array.from(element.children).forEach((child) => {
    const inputEl = child as HTMLInputElement;
    temp[inputEl.name] = inputEl.value;
  });
  const component = (
    <PanelCollapse
      title={temp.title}
      children={temp.content}
    />
  );
  return ReactDOM.render(component, element);
});


const getProductInfo = async (sku: string): Promise<any> => {
return await fetchBigCommerceApi(HTTP_METHOD.POST, new Headers(), {
  query: `query fetchProductBySku($sku: String, $currencyCode: currencyCode) {
    site {
    product(sku: $sku) {
        defaultImage {
        ...ImageFields
        }
      prices (currencyCode: $currencyCode, includeTax: true) {
        price {
                value
                currencyCode
        }
      }
        entityId
        sku
        name
    }
  }
}

fragment ImageFields on Image {
    imageUrl: url(width: 660)
}
  `,
  variables: {
      sku,
      currencyCode: localStorage.currency || 'NZD'
  }
})
};


interface AddToCartButton {
  text?: string;
  sku?: string;
}


window.Obiwan.renderAddToCartButtons = () => {
  const addToCartButtons = document.getElementsByClassName('react-add-to-cart');
  const isSoldOutElement = document.getElementById('isSoldOut') as HTMLInputElement;
  const isSoldOut: boolean = isSoldOutElement ? isSoldOutElement.value === 'True' : false;
  Array.from(addToCartButtons).forEach(element => {
    let price: number;
    let name: string;
    let imageUrl: string;
    let productId: number;
    const temp: AddToCartButton = {};
    Array.from(element.children).forEach((child) => {
      const inputEl = child as HTMLInputElement;
      temp[inputEl.name] = inputEl.value;
    });
    const sku = temp.sku;
    getProductInfo(sku!).then(r => r.json())
    .then(r => {
       price = r.data.site.product.prices.price.value;
       name = r.data.site.product.name;
       productId = r.data.site.product.entityId;
       imageUrl = r.data.site.product.defaultImage.imageUrl;
     });
    const onClick = () => {
      if (isSoldOut) {
        return;
      }
      const cart = Cart.getInstance();
      const cartItems = cart.getItems();
      const product: RegularProduct = {
        name: name,
        unit_price: price,
        imageUrl: imageUrl,
        sku: sku,
        productId: productId,
        quantity: cartItems[productId]?.quantity + 1 || 1,
      };
      cart.updateItem(product);

      renderOpenAddToCardModal({
        elementId: sku!,
        name,
        price: '' + price,
        imageUrl,
        editCartUrl: window.Obiwan.SHOPPING_CART_URL,
        proceedUrl: window.Obiwan.SHOPPING_CART_URL,
      });
    };

    const component = (
      <Button
        text={temp.text || 'Add to cart'}
        onClick={onClick}
        ariaLabel={temp.text || 'Add to cart'}
        button_type={BUTTON_TYPE.PRIMARY}
        icon="add_shopping_cart"
      />
    );
    return ReactDOM.render(component, element);
  });
};

window.Obiwan.renderAddToCartButtons();

const carousels = Array.from(document.getElementsByClassName('react-carousel'));
carousels.forEach(carouselElement => {
  const carousel = getCarouselComponent(carouselElement);
  return ReactDOM.render(carousel, carouselElement);
});

legal();

window.Obiwan.showCategoryPanel = showCategoryPanel;
window.Obiwan.attachShoppingCart = attachShoppingCart;

window.Obiwan.attachCartDiv = (id: string) => {
  const component = (<CartDiv />);
  const element = document.getElementById(id);
  if (element) {
    ReactDOM.render(component, element);
  }
};

window.Obiwan.renderPanel = renderPanel;
window.Obiwan.renderOpenAddToCardModal = renderOpenAddToCardModal;

window.Obiwan.returnsModal = (id: string) => {
  const component = (<ReturnsModal />);
  const element = document.getElementById(id);
  if (element) {
    ReactDOM.render(component, element);
  }
};

window.Obiwan.shippingModal = (id: string) => {
  const component = (<ShippingModal />);
  const element = document.getElementById(id);
  if (element) {
    ReactDOM.render(component, element);
  }
};

window.Obiwan.nav = (
  config: {
    thrawnURL: string;
    kenobiBlogURL: string;
  },
  loggedIn: boolean,
) => {
  // const loadCounter = localStorage.getItem('loadCounter');
  let showBanner = window.location.pathname === '/';

  // if (loadCounter) {
  //   // const c = JSON.parse(loadCounter);
  //   // showBanner = (c.counter < 2) && (window.location.pathname === '/');
  // }
  addElementToClassName('react-navigation', <PreLaunchNav showBanner={showBanner} loggedIn={loggedIn} navConfig={{ ...config, cartURL: window.Obiwan.SHOPPING_CART_URL, BASE_API_URL: BASE_API_URL }} />);
};
window.Obiwan.footer = (config: {
  thrawnURL: string;
  kenobiBlogURL: string;
}) => {
  addElementToClassName('react-footer', <PreLaunchFooter footerConfig={config} />);
};


window.Obiwan.shippingModal('modalTest');

window.Obiwan.returnsModal('modalTestReturns');

window.Obiwan.notifyMe = () => {
  const sku = (document.getElementsByClassName('productSku')[0] as HTMLInputElement).value;
  return ReactDOM.render(<NotifyMe sku={sku} />, document.getElementById('notifyMe'));
};


window.Obiwan.renderPartpayBanner = () => {
  ReactDOM.render(<PartpayBanner />, document.getElementById('partpay-banner'));
};

window.Obiwan.renderPriceTag = () => {
  const priceTags = document.getElementsByClassName('price-container__price');
  Array.from(priceTags).forEach((priceTag) => {
    const tag = priceTag as HTMLElement;
    const sku = tag.dataset.productSku || '';
    getProductInfo(sku).then(r => {
      if (r) {
        ReactDOM.render(
          <div className="text">
            ${r.data.site.product.prices.price.value} {localStorage.currency}
          </div>, priceTag);
      }
    });
  });
};

window.Obiwan.renderSignUpModal = () => {
  const focusableElements: Element[] = Array.from(document.querySelectorAll('a, button'));
  const modalElement: Element | null = document.getElementById('sign-up-newsletter-modal');
  // focusableElements.forEach((element) => {
  //   element.setAttribute('tabindex', '-1');
  // });

  // const imageURL = document.getElementById('specialOfferImageUrl') ? (document.getElementById('specialOfferImageUrl') as HTMLInputElement).value : undefined;
  const subtitle = document.getElementById('specialOfferSubtitle') ? (document.getElementById('specialOfferSubtitle') as HTMLInputElement).value : undefined;
  const discountCode = document.getElementById('specialOfferDiscountCode') ? (document.getElementById('specialOfferDiscountCode') as HTMLInputElement).value : undefined;
  if (!!localStorage.getItem('newsletterState') || !discountCode) { return; }

  const loadCounter = localStorage.getItem('loadCounter');
  const now = new Date().getTime();
  let shouldRender = true;
  let newLoadCounter = {};

  if (loadCounter) {
    const c = JSON.parse(loadCounter);
    // 604800000 = 604800 seconds + 000 milliseconds = 7 days
    if (now - c.timestamp > 604800000) {
      newLoadCounter = {
        timestamp: now,
        counter: 1,
      };
    } else {
      newLoadCounter = {
        timestamp: c.timestamp,
        counter: c.counter + 1,
      };
      shouldRender = c.counter < 2;
    }
  } else {
    newLoadCounter = {
      timestamp: now,
      counter: 1,
    };
  }

  const HubspotForm = () => {
    const targetId = `form-${uuidv4()}`;
    React.useLayoutEffect(() => {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/v2.js';
      document.body.appendChild(script);

      script.addEventListener('load', () => {
        if (window.hbspt) {
          window.hbspt.forms.create({
            portalId: '6410933',
            formId: 'f8f45977-0fb9-4137-bb32-34b1fbea9ea0',
            target: `#${targetId}`,
          });
        }
      });
    }, [targetId]);

    return (
      <div style={{ width: '100%' }} id={targetId} />
    );
  };

  const closeModal = () => {
    focusableElements.forEach((element) => {
      element.removeAttribute('tabindex');
    });
    ReactDOM.render(
      modalJSX(false),
      modalElement,
    );
  };
  const modalJSX = (open: boolean) => {
    return (
      <SignUpModal
        open={open}
        title="Sign Up to the Newsletter!"
        subtitle={subtitle}
        contentClassName="rich-text"
        isSmall={true}
        hasBackground={true}
        handleClose={closeModal}
        mobileCTA={{
          text: 'Sign Up',
          link: '/sign-up-newsletter',
        }}
      >
        <HubspotForm />
      </SignUpModal>
    );
  };

  localStorage.setItem('loadCounter', JSON.stringify(newLoadCounter));
  if (shouldRender) {
    ReactDOM.render(
      modalJSX(false),
      modalElement,
    );
  }
};

window.Obiwan.renderProductReviews = renderProductReviews;

window.Obiwan.renderMiniProductReviews = renderMiniProductReviews;

window.Obiwan.renderPrePurchaseButton = renderPrePurchaseButton;

window.Obiwan.renderPrePurchaseButtonToHtml = renderPrePurchaseButtonToHtml;

window.Obiwan.renderProgrammePitchAction = ProgrammePitchAction;

window.Obiwan.renderEveInstagramFeed = renderEve;

window.Obiwan.renderStepSection = StepSection;

window.Obiwan.renderCallToAction = CallToAction;

window.Obiwan.renderStepCarousel = StepCarousel;

window.Obiwan.renderTestimonial = TestimonialCarouselSection;

window.Obiwan.renderFAQSection = renderFAQSection;

window.Obiwan.renderProductsSection = ProductsSection;

window.Obiwan.renderSearchBox = SearchBox;

window.Obiwan.enablePartpay = true;

window.Obiwan.renderMentionedBy = MentionedBy;

window.Obiwan.renderFiveStarReviews = FiveStarReviews;

window.Obiwan.renderPageFeed = PageFeed;

window.Obiwan.renderProductCarousel = ProductCarouselSection;

window.Obiwan.renderProfileCarousel = ProfileCarouselSection;

window.Obiwan.renderProfileSection = ProfileSection;

window.Obiwan.renderBlogTagPanel = BlogTagPanel;

window.Obiwan.renderProductSlideShow = ProductSlideShow;

window.Obiwan.renderProductInformationWrapper = ProductInformationWrapper;

window.Obiwan.renderShippingReturns = ShippingReturns;

window.Obiwan.renderCTATileGrid = CTATileGrid;

window.Obiwan.renderProductReviewCarousel = ProductReviewCarousel;

window.Obiwan.renderValueBar = ValueBar;

window.Obiwan.renderProductSeller = ProductSeller;

window.Obiwan.renderBenefitsCallToAction = BenefitsCallToAction;

window.Obiwan.renderPromoCarousel = PromoCarousel;

main();